import { render, staticRenderFns } from "./EvaluationFormModal.vue?vue&type=template&id=65a9ff23&"
import script from "./EvaluationFormModal.vue?vue&type=script&lang=js&"
export * from "./EvaluationFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports